import React from 'react';

const GoalList = ({ goals, onSelectGoal }) => (
  <div className="goals-list">
    {goals.map(goal => (
      <div
        key={goal.id}
        className="goal-item"
        onClick={() => onSelectGoal(goal)}
        tabIndex={0}
        onKeyDown={e => { if (e.key === 'Enter') onSelectGoal(goal); }}
        aria-label={`View progress for ${goal.name}`}
      >
        <div style={{ fontWeight: 600 }}>{goal.name}</div>
        <div style={{ fontSize: '0.95rem', color: '#555', marginTop: 4 }}>
          Section: <b>{goal.section}</b> &nbsp; | &nbsp; Course Type: <b>{goal.courseType}</b>
        </div>
      </div>
    ))}
  </div>
);

export default GoalList;